import {useMutation} from '@apollo/client/react';
import {Question} from '@cp/model';
import {CHECK_QUESTION_WITH_GPT} from '../sharedQueries';

export function useCheckQuestionWithGpt() {
  const [checkQuestionWithGptMutation, {loading, error}] = useMutation<
    {checkQuestionWithGpt: Question},
    {moduleId: string; questionId: string}
  >(CHECK_QUESTION_WITH_GPT);

  /**
   * Check a question using GPT validation (Admin only)
   * @param moduleId
   * @param questionId
   * @returns Question if successful, otherwise undefined
   */
  const checkQuestionWithGpt = async (moduleId: string, questionId: string) => {
    const result = await checkQuestionWithGptMutation({
      variables: {moduleId, questionId},
      update: (cache, {data}) => {
        if (data?.checkQuestionWithGpt) {
          // Update the question in the cache
          cache.modify({
            id: cache.identify(data.checkQuestionWithGpt),
            fields: {
              status: () => data.checkQuestionWithGpt.status,
              statusNote: () => data.checkQuestionWithGpt.statusNote,
            },
          });

          // Also update any session that contains this question
          cache.modify({
            fields: {
              userSessions: (existingSessions = []) =>
                existingSessions.map((session: any) => {
                  if (session.questions) {
                    const updatedQuestions = session.questions.map((question: any) => {
                      if (question.id === questionId) {
                        return {
                          ...question,
                          status: data.checkQuestionWithGpt.status,
                          statusNote: data.checkQuestionWithGpt.statusNote,
                        };
                      }
                      return question;
                    });
                    return {
                      ...session,
                      questions: updatedQuestions,
                    };
                  }
                  return session;
                }),
            },
          });
        }
      },
    });

    return result.data?.checkQuestionWithGpt;
  };

  return {
    checkQuestionWithGpt,
    loading,
    error,
  };
}
